import React from 'react';
import { Button } from '../../ui/button';
import { OnboardingStepProps } from '../types';

export const AssetDiscovery: React.FC<OnboardingStepProps> = ({ onNext, onBack }) => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm text-gray-400">Root Domain</label>
          <input
            type="text"
            className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white"
            placeholder="example.com"
          />
        </div>
        <div className="space-y-2">
          <label className="text-sm text-gray-400">IP Ranges (Optional)</label>
          <input
            type="text"
            className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white"
            placeholder="192.168.1.0/24"
          />
        </div>
        <div className="space-y-2">
          <label className="flex items-center space-x-2">
            <input type="checkbox" className="rounded border-gray-700 bg-gray-800/30" />
            <span className="text-sm text-gray-400">Include subdomains</span>
          </label>
          <label className="flex items-center space-x-2">
            <input type="checkbox" className="rounded border-gray-700 bg-gray-800/30" />
            <span className="text-sm text-gray-400">Scan cloud assets</span>
          </label>
        </div>
      </div>
      <div className="flex items-center space-x-3">
        <Button variant="outline" onClick={onBack}>Back</Button>
        <Button className="flex-1" onClick={onNext}>Start Discovery</Button>
      </div>
    </div>
  );
};